import React, { useState, useEffect, useCallback } from 'react';
import constClass from '../../Constants/Constants';
const EventInfo = ({ siteId, event, checkinId, backClick }) => {
  const [eventInfo, setEventInfo] = useState(null);

  const refreshCheckData = useCallback(() => {
    var event_info = event.m_event_infos.find(e => e.checkin_id === Number(checkinId));
    setEventInfo(event_info);
  }, [event, checkinId]);

  useEffect(() => {
    refreshCheckData();
  }, [refreshCheckData]);

  return (
    <React.Fragment>
      <div className="frame61-center">
        <div className="frame61">
          <div className="checkin_text">
            チェックイン
          </div>
          <img src={`/${siteId}/icon-check.png`} alt={'チェック'} />
        </div>
      </div>
      <div className="frame62_detail mt-4">
        <div className='frame62_detail_body'>
          {eventInfo &&
            <React.Fragment>
              <div className="info_notice_title_text mb-3">
                {eventInfo.notice_title}
              </div>
              {eventInfo.notice_image_url && <img className="info_mask_group" src={`/${siteId}/${constClass.CHECKIN_IMAGE_DIR}${eventInfo.notice_image_url}`} alt={eventInfo.notice_title} style={{ objectFit: 'cover' }} />}
              {!eventInfo.notice_image_url && <img className="info_mask_group" src={`/${siteId}/noimage.png`} alt="noimage" style={{ objectFit: 'cover' }} />}
              <div className="info_notice_summary my-3">
                {eventInfo.notice_summary}
              </div>
              <div className="info_notice_detail mb-4">
                {eventInfo.notice_detail}
              </div>
              <button
                onClick={() => backClick()}
                className="button text-black bg-lightwhite mt-3">
                閉じる
              </button>
            </React.Fragment>
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default EventInfo;